import { AdHocReportBuilder } from "../../ad-hoc-report-builder";

export class SavedReportsUI {
    private parent: AdHocReportBuilder;
    private wrapper: HTMLElement;
    private linkWrapper: HTMLDivElement;

    constructor(parent: AdHocReportBuilder, wrapper: HTMLElement) {
        this.parent = parent;
        this.wrapper = wrapper;
    }

    buildUi(): void {
        // Add wrapper for links
        this.linkWrapper = document.createElement("div");
        this.linkWrapper.id = "ahrb-saved-reports-wrapper";
        this.wrapper.appendChild(this.linkWrapper);
    }

    addReport(id: number, name: string): void {
        const reportItem = document.createElement('div');
        reportItem.classList.add('ahrb-saved-reports-item');
        // @ts-ignore
        reportItem.innerHTML = `<a href="${window.ergmapsScriptsObject.siteUrl}/ecms-reporting/?report_id=${id}">
            <span>${name}</span>
            <i class="fas fa-times ad-hoc-report-delete"></i>
        </a>`;

        this.linkWrapper.append(reportItem);

        // Handle report deletion
        reportItem.querySelector('.ad-hoc-report-delete').addEventListener('click', this.handleReportDeletion.bind(this, id));
    }

    /**
     * Delete report
     * 
     * @param {number} id
     * @param {Event} event
     */
    handleReportDeletion(id: number, event: Event) {
        event.preventDefault();

        if (confirm("Are you sure you want to delete the report?") == true) {
            this.parent.onReportDeletion(id, event.target as HTMLElement);
        }
    }


    async loadExistingReports() {
        // @ts-ignore
        const response = await fetch(`${window.ergmapsScriptsObject.ajaxUrl}?action=get_ad_hoc_reports`);
        if (!response) return;
        
        const responseJson = await response.json();

        responseJson.forEach(element => {
            this.addReport(element.id, element.title);
        });
    }
}